import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'FormularyReview',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewFormularyReviewUi()) {
            this.logout();
            return;
        }
        this.GetInfo(1);
    },

    computed: {
        isPharmacyRole() {
            return !!(this.loginDetails && this.loginDetails.userType === 4);
        }
    },

    data() {
        return {
            items: [],
            totalCount: 0,
            pageNo: 1,
            pageSize: 20,
            searchText: '',
            loading: false,
            reviewLoading: false,
            reviewForm: {
                item: null,
                approve: true,
                note: ''
            }
        };
    },

    methods: {
        GetInfo(page) {
            this.pageNo = page || 1;
            this.loading = true;
            this.$http.GetFormularyPendingReview(this.pageNo, this.pageSize, this.searchText)
                .then(resp => {
                    this.items = resp.data.info || [];
                    this.totalCount = resp.data.count || 0;
                })
                .catch(err => {
                    this.$message.error(err.response?.data || 'حدث خطأ في تحميل البيانات');
                })
                .finally(() => { this.loading = false; });
        },

        approvalLabel(status) {
            if (status === 0) return 'قيد مراجعة الصيدلة';
            if (status === 1) return 'معتمد من الصيدلة';
            if (status === 2) return 'منشور';
            return '-';
        },

        approvalBadgeClass(status) {
            if (status === 0) return 'bg-label-warning';
            if (status === 1) return 'bg-label-info';
            if (status === 2) return 'bg-label-success';
            return 'bg-label-secondary';
        },

        formatDate(d) {
            if (!d) return '-';
            try {
                return new Date(d).toLocaleDateString('ar-LY');
            } catch { return d; }
        },

        openReviewDialog(item, approve) {
            this.reviewForm = { item, approve, note: '' };
            const el = document.getElementById('reviewModal');
            if (el && window.bootstrap) new window.bootstrap.Modal(el).show();
        },

        openApproveDialog(item, approve) {
            this.openReviewDialog(item, approve);
        },

        submitReview() {
            if (!this.reviewForm.item) return;
            if (!this.reviewForm.approve && !this.reviewForm.note.trim()) {
                this.$message.warning('يرجى ذكر سبب الرفض');
                return;
            }

            this.reviewLoading = true;
            const body = {
                id: this.reviewForm.item.id,
                approve: this.reviewForm.approve,
                note: this.reviewForm.note
            };

            const req = this.isPharmacyRole
                ? this.$http.ReviewFormularyPharmacy(body)
                : this.$http.ApproveFormularyMinistry(body);

            req.then(resp => {
                    const msg = typeof resp.data === 'string' ? resp.data : 'تمت العملية بنجاح';
                    this.$message.success(msg);
                    // إغلاق الـ Modal
                    const el = document.getElementById('reviewModal');
                    if (el && window.bootstrap) {
                        const m = window.bootstrap.Modal.getInstance(el);
                        if (m) m.hide();
                    }
                    this.GetInfo(this.pageNo);
                })
                .catch(err => {
                    this.$message.error(err.response?.data || 'حدث خطأ');
                })
                .finally(() => { this.reviewLoading = false; });
        }
    }
};
